export { default } from './Grid';



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductGrid/Grid/index.js